import React, { useContext, useState } from "react";
import { isEmpty } from "lodash";
import moment from "moment";

import { expenseColors, columnTitles } from "./WeeklyDetails.utils";
import Modal from "../../../../../components/modalComponent/ModalComponent";
import ExpenseReportModal from "../../../components/ExpenseReportModal";
import { ExpenseReportsContext } from "../../ExpenseReportsContext";
import { expenseReportsListApiUpsellProvider } from "../../../../../lib/api/providers";
import { handleError } from "../../../sagas";
import { roles, EXPENSE_STATUS_ID } from "../../../../../configs/constants";

const expenseBackgroundColor = data => {
  return expenseColors[data.status.id];
};

const expenseTextColor = data => {
  return data.status.id === 1 ? "text-black" : "text-white";
};

const WeeklyListRow = ({
  getModalTitle,
  setIsModalVisible,
  setExpenseSelected,
  date,
  weeklyExtraData,
  typeName,
  detail
}) => {
  let dateFiltered = [];

  if (typeName === "dailyReport") {
    dateFiltered = weeklyExtraData.filter(item => moment(item.date).format("YYYY-MM-DD") === date);
  }

  return (
    <td className="p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
      {typeName === "dailyReport" ? (
        <div className="flex flex-col">
          <div className="flex items-center mb-2">
            <button className="bg-blue-400 mr-5 rounded-full h-8 w-8 flex items-center justify-center cursor-default">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                id="svg4"
                version="1.1"
                viewBox="0 0 68.037 83.15"
                height="14"
                width="18"
              >
                <g transform="translate(-211.178 -759.034)" id="doc-dark">
                  <path
                    fill="#ffffff"
                    transform="translate(211.178 740.534)"
                    d="M68.031,69.9V50.1c0-.034.005-.066.005-.1a3.759,3.759,0,0,0-.858-2.391l-.016-.02c-.07-.084-.143-.164-.219-.241l-.033-.034c-.033-.033-.064-.069-.1-.1l-27.6-27.6,0,0c-.077-.077-.158-.149-.241-.219-.026-.022-.053-.043-.08-.064-.06-.048-.122-.094-.185-.138l-.1-.065c-.066-.043-.134-.084-.2-.123-.028-.016-.055-.033-.084-.049q-.137-.073-.279-.135c-.039-.017-.078-.031-.118-.047-.063-.025-.126-.048-.19-.07l-.133-.042c-.073-.021-.146-.04-.22-.057-.033-.007-.065-.017-.1-.023-.106-.021-.213-.037-.32-.049l-.1-.009c-.089-.008-.178-.012-.267-.014-.019,0-.037,0-.056,0H3.78A3.78,3.78,0,0,0,0,22.28V97.87a3.78,3.78,0,0,0,3.78,3.78H64.252a3.78,3.78,0,0,0,3.78-3.78V77.461C68.032,85.063,68.031,69.9,68.031,69.9ZM40.315,31.4,55.127,46.217H40.315ZM60.472,94.091H7.559V26.059h25.2V50a3.78,3.78,0,0,0,3.78,3.78H60.472V69.9c.009,7.663.077,13.727,0,7.564Z"
                    id="XMLID_223_"
                  />
                </g>
              </svg>
            </button>
            {dateFiltered[0] ? dateFiltered[0].nb_visits : 0} visites
          </div>
          <div className="flex items-center">
            <button className="bg-orange-500 mr-5 rounded-full h-8 w-8 flex items-center justify-center cursor-default">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 24 24">
                <path
                  fill="#ffffff"
                  d="M23.5 7c.276 0 .5.224.5.5v.511c0 .793-.926.989-1.616.989l-1.086-2h2.202zm-1.441 3.506c.639 1.186.946 2.252.946 3.666 0 1.37-.397 2.533-1.005 3.981v1.847c0 .552-.448 1-1 1h-1.5c-.552 0-1-.448-1-1v-1h-13v1c0 .552-.448 1-1 1h-1.5c-.552 0-1-.448-1-1v-1.847c-.608-1.448-1.005-2.611-1.005-3.981 0-1.414.307-2.48.946-3.666.829-1.537 1.851-3.453 2.93-5.252.828-1.382 1.262-1.707 2.278-1.889 1.532-.275 2.918-.365 4.851-.365s3.319.09 4.851.365c1.016.182 1.45.507 2.278 1.889 1.079 1.799 2.101 3.715 2.93 5.252zm-16.059 2.994c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5.672 1.5 1.5 1.5 1.5-.672 1.5-1.5zm10 1c0-.276-.224-.5-.5-.5h-7c-.276 0-.5.224-.5.5s.224.5.5.5h7c.276 0 .5-.224.5-.5zm2.941-5.527s-.74-1.826-1.631-3.142c-.202-.298-.515-.502-.869-.566-1.511-.272-2.835-.359-4.441-.359s-2.93.087-4.441.359c-.354.063-.667.267-.869.566-.891 1.315-1.631 3.142-1.631 3.142 1.64.313 4.309.497 6.941.497s5.301-.184 6.941-.497zm2.059 4.527c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5.672 1.5 1.5 1.5 1.5-.672 1.5-1.5zm-18.298-6.5h-2.202c-.276 0-.5.224-.5.5v.511c0 .793.926.989 1.616.989l1.086-2z"
                />
              </svg>
            </button>
            {dateFiltered[0] ? parseFloat(dateFiltered[0].trips_distance).toFixed(2) : "0.00"} km
          </div>
        </div>
      ) : (
        detail.map(data => (
          <div
            className={`${expenseBackgroundColor(data)} 
                      ${expenseTextColor(data)}
                      rounded-full text-white p-2 w-full h-8 my-1 text-center cursor-pointer`}
            onClick={() => {
              setExpenseSelected(data);
              getModalTitle(typeName);
              setIsModalVisible(true);
            }}
          >
            {data.warning && "⚠️"} {Number.parseFloat(data.price).toFixed(2)} € {data.warning && "⚠️"}
          </div>
        ))
      )}
    </td>
  );
};

const WeeklyDetailsList = ({ weeklyExtraData, weeklyData, expenseReportsTypeList }) => {
  const filteredWeeklyData = (typeName, item) => item.filter(item => item.type && item.type.type === typeName);

  const {
    userId,
    weekDate,
    token,
    expenseReportsUserWeekly,
    userRoleId,
    selectedUserEmail,
    handleOnClickDetailsView
  } = useContext(ExpenseReportsContext);
  const [expenseSelected, setExpenseSelected] = useState(null);
  const [modalTitle, setModalTitle] = useState("");

  const getModalTitle = typeName => {
    if (userRoleId === 3) setModalTitle("Qualification manager");
    else if (userRoleId === 2) setModalTitle("Validation comptable");
    else setModalTitle(`Note de frais : ${typeName}`);
  };

  const requestToTriggered = () => {
    handleOnClickDetailsView({
      match: {
        email: selectedUserEmail
      },
      start_date: moment(weekDate).format("YYYY-MM-DD")
    });
  };
  const [isModalVisible, setIsModalVisible] = useState(false);

  const getChooseBetweenValidateAndPrevalidate = typeName => {
    if (userRoleId === roles.DIRECTOR) return true;
    else if (userRoleId === roles.ADMIN) {
      let findOnePending = 0;

      if (!isEmpty(weeklyData)) {
        Object.keys(weeklyData).forEach(key => {
          const toto = weeklyData[key].forEach(item => {
            if (item.type.type === typeName && item.status.id === EXPENSE_STATUS_ID.PENDING) findOnePending = 1;
          });
        });
      }
      return findOnePending !== 1;
    }
    return false;
  };

  const requestAllValidate = async typeName => {
    if (!isEmpty(expenseReportsUserWeekly) && !isEmpty(expenseReportsUserWeekly[0].data)) {
      let filteredByType = [];
      if (typeName) filteredByType = expenseReportsUserWeekly[0].data.filter(item => item.type.type === typeName);

      const paramsToSend = {
        _ids: typeName
          ? filteredByType.map(item => item._id)
          : expenseReportsUserWeekly[0].data.filter(item => item._id)
      };
      const endpoint = getChooseBetweenValidateAndPrevalidate(typeName) ? "/validate" : "/prevalidate";

      try {
        await expenseReportsListApiUpsellProvider.post(endpoint, paramsToSend, {
          headers: {
            Authorization: token
          }
        });
        requestToTriggered();
      } catch (e) {
        handleError(e);
      }
      setIsModalVisible(false);
    }
  };

  const isBtnAllValidateByTypeDisplayed = typeName => {
    const matchStatusId = userRoleId === 3 ? EXPENSE_STATUS_ID.PENDING : EXPENSE_STATUS_ID.PREVALIDATED;

    if (!isEmpty(expenseReportsUserWeekly) && !isEmpty(expenseReportsUserWeekly[0].data)) {
      let getExpenseReportsByType = [];

      if (userRoleId === roles.ADMIN || userRoleId === roles.DIRECTOR)
        getExpenseReportsByType = expenseReportsUserWeekly[0].data.filter(
          item =>
            item.type.type === typeName &&
            (item.status.id === EXPENSE_STATUS_ID.PENDING || item.status.id === EXPENSE_STATUS_ID.PREVALIDATED)
        );
      else
        getExpenseReportsByType = expenseReportsUserWeekly[0].data.filter(
          item => item.type.type === typeName && item.status.id === matchStatusId
        );

      return !isEmpty(getExpenseReportsByType);
    }
    return false;
  };

  return (
    <div className="w-3/4 p-2">
      <table className="w-full">
        <thead>
          <tr>
            {columnTitles(weekDate).map(columnTitle => (
              <th
                index={columnTitle}
                className="px-6 py-3 border-b border-gray-200 text-left leading-4 font-medium text-gray-800 tracking-wider"
              >
                {columnTitle}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white">
          {expenseReportsTypeList &&
            ["dailyReport", ...expenseReportsTypeList].map(typeName => (
              <tr className="hover:bg-gray-100">
                <td className="p-6 whitespace-no-wrap border-b border-gray-200 text-md leading-5 text-gray-900">
                  {typeName !== "dailyReport" && (
                    <div className="flex flex-col">
                      {typeName}
                      {isBtnAllValidateByTypeDisplayed(typeName) && (
                        <a
                          className="mt-2 cursor-pointer underline font-bold text-orange-400"
                          onClick={() => {
                            requestAllValidate(typeName);
                          }}
                        >
                          {getChooseBetweenValidateAndPrevalidate(typeName) ? "Tout valider" : "Tout accepter"}
                        </a>
                      )}
                    </div>
                  )}
                </td>
                {!isEmpty(weeklyData) &&
                  Object.keys(weeklyData).map(key => {
                    return (
                      <WeeklyListRow
                        getModalTitle={getModalTitle}
                        setIsModalVisible={setIsModalVisible}
                        setExpenseSelected={setExpenseSelected}
                        weeklyExtraData={weeklyExtraData}
                        typeName={typeName}
                        date={key}
                        detail={filteredWeeklyData(typeName, weeklyData[key])}
                      />
                    );
                  })}
              </tr>
            ))}
        </tbody>
      </table>

      <Modal width="651px" title={modalTitle} showModal={isModalVisible} closeModal={() => setIsModalVisible(false)}>
        <ExpenseReportModal
          userId={userId}
          userRoleId={userRoleId}
          expensesTab={[expenseSelected]}
          isModalVisible={isModalVisible}
          closeModal={() => setIsModalVisible(false)}
          requestToTriggered={() => requestToTriggered()}
        />
      </Modal>
    </div>
  );
};

export default WeeklyDetailsList;



// WEBPACK FOOTER //
// src/modules/presence/expenseReports/expenseReportsWeekly/weeklyDetails/WeeklyDetailsList.js